/* eslint-disable */
<template>
  <div id="modal1" class="modal">
    <div class="modal-content">
      <span class="close material-icons-outlined">close</span>

      <video class="video" id="video" controls>
        <source
          src="https://wanviewvitrinevideos.s3.eu-west-3.amazonaws.com/WANVIEW_720p.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  </div>
  <div class="container">
    <div class="header">
      <div class="sub-title">Interview</div>
      <div class="title">
        <h1>
          <span>Intermarché et la solution Wanview :</span> <br />
          une autonomie déjà validée par les équipes sur le terrain
        </h1>
      </div>

      <div class="date-author">
        <p>22 mars 2022 - <span>Wanview</span></p>
      </div>
    </div>
    <article>
      <div class="header">
        <div class="content">
          <div class="paragraph">
            <p>
              <b
                >Laurent Lacon est responsable de magasin à l’Intermarché de
                Tulle, un magasin transféré et agrandi en 2008 avec une surface
                de près de 3000m². Il est en charge de l’ensemble de la gestion
                du personnel, de l’organisation des équipes, mais aussi du relai
                de la communication et de l’affichage digital - notamment des
                promotions - auprès des clients en magasin.</b
              >
            </p>
            <p>
              Laurent, son équipe et le magasin Intermarché de Tulle ont aidé au
              développement de Wanview, afin de mieux définir les besoins et
              attentes pour l’utilisation et la mise en place de la solution “en
              conditions réelles”. Laurent nous parle de son usage des écrans et
              de la solution Wanview.
            </p>
          </div>
          <aside>
            <img
              src="../assets/png/800px-Intermarché_Logo.png"
              alt="portrait"
            />
            <p>Laurent Lacon - Intermarché de Tulle - 2021</p>
          </aside>
        </div>
      </div>
    </article>
    <article>
      <div class="header">
        <h2>
          Pourquoi et comment avez-vous fait le choix de l’affichage digital en
          magasin ?
        </h2>
      </div>
      <div class="content">
        <p>
          Nous étions déjà convaincus par l’affichage dynamique : c’est un
          support moderne, visible, qui trouve facilement sa place auprès des
          clients, dans les rayons, aux caisses…. À l’ouverture du nouveau
          magasin en 2008, nous avons fait le pari de l’investissement pour
          l’équiper entièrement, avec un parc écran qui correspond à nos
          besoins, nos usages et notre magasin. Aujourd’hui, nous avons un écran
          géant extérieur, un écran géant intérieur pour les rayons
          traditionnels - qui a remplacé des petits écrans pour chacun des
          rayons -, un totem à l’entrée du magasin et 2 écrans en arrière de
          caisse. <br />
          Pour notre magasin, récent et moderne, cela nous permet aussi d’éviter
          de polluer l’expérience client avec de multiples affiches :
          <br />
          <b
            >tout passe par les écrans, et c’est plus agréable pour le
            public.</b
          >
        </p>
      </div>
    </article>
    <article>
      <div class="header">
        <h2>Quels types de spots diffusez-vous ?</h2>
      </div>
      <div class="content">
        <p>
          <b
            >Aujourd’hui, nos écrans sont les outils privilégiés pour relayer
            les promotions</b
          >
          en cours, celles des prospectus reçus par nos clients. Mais ils nous
          permettent également de valoriser nos services, et toutes les
          actualités ou événements magasin !
        </p>
      </div>
    </article>
    <article>
      <div class="video" data-wan-trigger="modal" data-wan-data="modal1">
        <video poster="../assets/png/1.14sec.webp"></video>
        <img src="../assets/png/playBtn.svg" alt="play" />
      </div>
    </article>
    <article>
      <div class="header">
        <h2>
          Avant Wanview, comment faisiez-vous pour piloter votre affichage ?
        </h2>
      </div>
      <div class="content">
        <p>
          C’était une petite organisation : un point par téléphone tous les
          lundis matins pour briefer notre prestataire sur l’ensemble des
          promotions de la semaine. Ce n’était pas extrêmement chronophage, mais
          il fallait récupérer les informations en amont, attendre la production
          et la mise en ligne des spots… Et surtout, on n’avait moins de
          réactivité qu’aujourd’hui !
        </p>
      </div>
    </article>
    <article>
      <div class="header">
        <h2>Et aujourd’hui, avec Wanview ?</h2>
      </div>
      <div class="content">
        <p>
          On part donc d’un outil pratique et dynamique - l’affichage digital-
          mais sur lequel on n’a peu de marge de manœuvre, donc pas vraiment
          flexible. Aujourd’hui avec Wanview, on peut véritablement se permettre
          d’avoir davantage de réactivité sur nos spots et nos écrans, on
          l’utilise spontanément parce qu’on est autonome. On fonctionne
          toujours de façon hebdomadaire, pour les promotions de la semaine,
          mais on communique plus qu’avant “à l’instant T”. Un responsable de
          rayon fait remonter une information, on crée le spot qui convient et
          c’est en ligne quelques minutes après. Wanview,
          <b>on l’utilise tous les jours !</b>
        </p>
      </div>
    </article>
    <article>
      <div class="citation">
        <img src="../assets/png/quotes.svg" alt="quotes" />
        <h3>
          Aujourd’hui avec Wanview, on peut véritablement se permettre d’avoir
          davantage de réactivité sur nos spots et nos écrans,
          <b>on l’utilise spontanément parce qu’on est autonome.</b>
        </h3>
      </div>
    </article>
    <article class="paragraphe-image">
      <div class="header">
        <h2>
          Pourquoi changer ? Quels sont aujourd’hui les véritables atouts de
          Wanview dans votre utilisation de la solution ?
        </h2>
      </div>
      <div class="content float">
        <img src="../assets/png/21sec.webp" alt="thumbnail" />
        <p>
          La réactivité et l’adaptabilité, c’est vraiment ce qui nous plait !
          Par exemple, lorsque l’on a une promotion sur la coquille
          Saint-Jacques à prix coûtant : si le prix change, en 2 clics, c’est à
          jour sur nos écrans ! C’est quasi instantané ! <br />
        </p>
        <p>
          Et puis, la prise en main est intuitive et simple : pas besoin de s’y
          connaître ! Aujourd’hui, dans notre organisation, la communication et
          les spots sont pilotés par mon adjoint et moi. Les responsables de
          rayon et l’ensemble de l’équipe savent déjà que l’outil existe et tous
          sont proactifs sur ce sujet et la mise à jour des écrans et des
          promotions diffusés. À terme, tous les responsables de rayon seront
          sûrement amenés à utiliser Wanview, on pourra déléguer !
        </p>
      </div>
    </article>
    <article>
      <div class="header">
        <h2>Est-ce que c’est vraiment si facile de créer vos spots ?</h2>
      </div>
      <div class="content">
        <p>
          Oui ! <b>Dans la grande distribution, on a des besoins communs</b>,
          d’autant plus pour les rayons traditionnels : une banque d’image pour
          l’ensemble des produits, les labels ou indications d’origines et des
          templates de spots qui respectent la charte de l’enseigne. Les spots
          sont directement déclinés et adaptés pour nos différents formats par
          Wanview lorsque l’on sélectionne les écrans de diffusion. Avec tout
          ça, <b>créer un spot est un jeu d’enfant !</b>
        </p>
        <p>
          De notre côté, on apprécie également beaucoup de pouvoir alimenter
          notre banque d’images de façon autonome : aujourd’hui, on peut prendre
          directement les photos de nos produits et on les intègre dans nos
          spots !
        </p>
      </div>
    </article>
    <article>
      <div class="header">
        <h2>
          Et demain, quelles sont vos ambitions pour l’affichage digital de
          votre magasin ?
        </h2>
      </div>
      <div class="content">
        <p>
          Nous pensons à développer le non- alimentaire sur les opérations de
          rentrée ou le blanc, et même le jardin ou le plein air. Il suffirait
          pour ça de développer notre banque d’images pour ces produits, même si
          l’on peut faire des photos nous-mêmes.
        </p>
      </div>
    </article>
    <article class="border">
      <div class="header">
        <h2>Recommanderiez-vous Wanview ?</h2>
      </div>
      <div class="content">
        <p>
          Oui ! C’est un outil utile, facile, rapide, et conçu pour nous !
          Beaucoup de magasins sont déjà équipés en PLV d’affichage dynamique,
          mais souvent, on ne l’utilise pas à pleine capacité car cela demande
          du temps, de l’anticipation ou des connaissances techniques. Avec
          Wanview, c’est simple et l’outil est bien ficelé ! Foncez !
        </p>
      </div>
    </article>
    <div class="footer">
      <div class="content">
        <img src="../../public/logo_wanview_white.svg" alt="logo Wanview" />
        <h2>
          La solution <span>100% autonome</span> <br />pour animer vos écrans
        </h2>
        <a href="/#formulaire">
          <button>
            En savoir plus<span class="material-icons-outlined">
              navigate_next
            </span>
          </button></a
        >
      </div>
      <img
        src="../assets/png/pyramid.webp"
        alt="pyramid"
        width="200"
        height="200"
        class="img-parallax"
        style="left: -25px; top: -125px"
        data-speed="0.2"
        data-position-initial="-900"
      />
      <img
        src="../assets/png/torebronze.png"
        alt="ring bronze"
        width="218"
        height="218"
        class="img-parallax"
        style="right: 25px; top: 50px"
        data-speed="0.1"
        data-position-initial="-350"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  mounted() {
    document.addEventListener("wanModal", (e) => {
      const video = document.getElementById("video");
      if (e.detail.modalOpen) {
        video.play();
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
    const triggersModals = Array.from(
      document.querySelectorAll('[data-wan-trigger="modal"]')
    );
    let parallax = document.querySelectorAll(".img-parallax");

    document.addEventListener("scroll", (e) => {
      e;
      for (let img of parallax) {
        var posY = parseInt(img.dataset.positionInitial);
        var speed = parseFloat(img.dataset.speed);
        var position = posY + window.scrollY * speed;
        img.style.top = Math.round(position) + "px";
      }
    });
    if (triggersModals) {
      for (let btn_modal of triggersModals) {
        btn_modal.addEventListener("click", () => {
          if (btn_modal.getAttribute("data-wan-data")) {
            var selector = btn_modal.getAttribute("data-wan-data");
            var targets = document.getElementById(selector);
            targets.classList.add("show");
            document.dispatchEvent(
              new CustomEvent("wanModal", {
                detail: {
                  modalOpen: true,
                },
              })
            );

            var close = document.getElementsByClassName("close")[0];
            close.onclick = () => {
              targets.classList.remove("show");
              document.dispatchEvent(
                new CustomEvent("wanModal", {
                  detail: {
                    modalOpen: false,
                  },
                })
              );
            };
            window.onclick = (event) => {
              if (event.target == targets) {
                targets.classList.remove("show");
                document.dispatchEvent(
                  new CustomEvent("wanModal", {
                    detail: {
                      modalOpen: false,
                    },
                  })
                );
              }
            };
          }
        });
      }
    }
  },
};
</script>

<style lang="scss">
@import "../assets/variables.scss";
@import "../styles/testimonial.scss";
</style>
